import React, { useEffect } from "react";
import AuthActions from "../../stores/auth/Actions";
import { connect } from "react-redux";
import Spinner from "../../components/Common/Spinner";
import AuthService from "../../services/auth/AuthService";

const LogOut = (props) => {
  useEffect(() => {
    props.logoutUser();
    AuthService.notifyLogOutAllTabs();
    return () => {};
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <Spinner size={40} />;
};

const mapStateToProps = (state) => ({
  logoutUserData: state.auth.logoutUserData,
  logoutUserLoading: state.auth.logoutUserLoading,
  logoutUserError: state.auth.logoutUserError,
});

const mapDispatchToProps = {
  logoutUser: AuthActions.logoutUser,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(LogOut);